<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10nnycC/tc-custom/9780369718716.jpg?1743831382716" alt="This image is the cover for the book Texas Cinderella and Would-Be Wilderness Wife"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Texas Cinderella and Would-Be Wilderness Wife
      </h1>
      <p class="bookDescription body article font2">
        <b>Wanted: the perfect partner</b><br/><br/><i>Texas Cinderella </i>by Winnie Griggs<br/><br/> After life on her family's farm, Cassie Lynn Vickers relishes her freedom working in town. Until her father suddenly demands she come home. Her only option? Convince handsome newcomer Riley Walker to marry her. Riley is on the run to keep his niece and nephew safe from his crooked half brother. But a delay in Turnabout, Texas, shows him everything he didn't know he was missing: home, family—and Cassie Lynn.<br/><br/><i>Would-Be Wilderness Wife</i> by Regina Scott<br/><br/> Drew Wallin's brother is determined to see him married—so he kidnaps Drew a prospective bride. Not only is Catherine Stanway beautiful, but she's a nurse who can help their ailing mother. Catherine has traveled West to use her skills to save lives, not to find a husband. If she gives in to Drew's matchmaking family, she'll be risking her already bruised heart. But maybe it's time she takes the ultimate risk!
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Winnie Griggs, Regina Scott
      </h2>
      
      <p class="authorDescription body article">Winnie Griggs learned the art of storytelling as a child when she and her siblings spent countless hours exploring the overgrown area around her South Louisiana home, building forts, stalking big game and keeping watch for pirate ships on the nearby bayou. She now happily shares the product of her active imagination with the readers of Love Inspired Historical books<BR /><BR />You can learn more about Winnie at winniegriggs.com or connect with her at www.facebook.com/WinnieGriggs.Author</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?03abbf06